const SETTINGS = {
    wide: {
        count: 56,
        focusRatio: 0.5,
        focus: { x: { min: 52, max: 98 }, y: { min: 2, max: 46 } },
        spread: { x: { min: 2, max: 98 }, y: { min: 2, max: 92 } },
    },
    narrow: {
        count: 44,
        focusRatio: 0.65,
        focus: { x: { min: 2, max: 98 }, y: { min: 1, max: 14 } },
        spread: { x: { min: 2, max: 98 }, y: { min: 2, max: 92 } },
    },
    size: { min: 0.45, max: 1.3 },
    duration: { min: 2.4, max: 6 },
    delay: { min: 0, max: 6 },
};

export default class Sparkle {
    constructor() {
        this.$root = document.querySelector(".character__sparkles");
        if (!this.$root) return;

        this.init();
    }

    init() {
        const preset = window.matchMedia("(max-width: 799px)").matches ? SETTINGS.narrow : SETTINGS.wide;
        const fragment = document.createDocumentFragment();

        for (let i = 0; i < preset.count; i++) {
            fragment.appendChild(this.createSparkle(preset));
        }

        this.$root.appendChild(fragment);
    }

    createSparkle(preset) {
        const $sparkle = document.createElement("span");
        const area = Math.random() < preset.focusRatio ? preset.focus : preset.spread;

        $sparkle.className = "character__sparkle";
        $sparkle.style.setProperty("--charaSparkleX", `${this.random(area.x.min, area.x.max).toFixed(2)}%`);
        $sparkle.style.setProperty("--charaSparkleY", `${this.random(area.y.min, area.y.max).toFixed(2)}%`);
        $sparkle.style.setProperty("--charaSparkleSize", this.random(SETTINGS.size.min, SETTINGS.size.max).toFixed(2));
        $sparkle.style.setProperty("--charaSparkleDur", `${this.random(SETTINGS.duration.min, SETTINGS.duration.max).toFixed(2)}s`);
        $sparkle.style.setProperty("--charaSparkleDelay", `${this.random(SETTINGS.delay.min, SETTINGS.delay.max).toFixed(2)}s`);

        return $sparkle;
    }

    random(min, max) {
        return min + Math.random() * (max - min);
    }
}
